import { create } from 'zustand';

interface ResizeInteractionStore {
  /** Id of the item whose resize handle is currently held, or null when no resize drag is in progress. */
  resizingId: string | null;
  start: (id: string) => void;
  /**
   * Ends `id`'s drag. A no-op while another item's drag is in progress, so one item's unmount never
   * clears another's.
   */
  end: (id: string) => void;
}

/**
 * Whether a resize drag is in progress anywhere on the stage.
 *
 * `Resizable` sets it on handle mouse-down and clears it on mouse-up, or when the resizing item unmounts
 * mid-drag. It exists for the parts of the Studio that must step aside during a drag but are not the
 * resizing item's own ancestors — the widget actions bar being the case that matters (see
 * `WidgetActionsBarWrapper`). The per-container `resizingItemId` state stays the way a container tells
 * its own children which item is resizing.
 */
export const useResizeInteractionStore = create<ResizeInteractionStore>(set => ({
  resizingId: null,
  start: id => set(() => ({ resizingId: id })),
  end: id => set(state => (state.resizingId === id ? { resizingId: null } : state))
}));
